// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609030523/js/" + chunkId + "." + {"44":"e8ac7d5c","225":"553782fd","481":"59fff106","486":"719be8c5","770":"8f9b69e2"}[chunkId] + ".0.191421432744185.chunk.js";
};